module.exports = __webpack_public_path__ + "img/player-next.51a06fd0.svg";